import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService, IsophiCoreService } from '@isophi/core-legacy';
import { TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';

import { KindergartenService } from '../services/kindergarten.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);

  private readonly isophiCoreService = inject(IsophiCoreService);

  private readonly translocoService = inject(TranslocoService);

  private readonly kindergartenService = inject(KindergartenService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = req.headers;

    headers = headers
      .set('app-name', this.isophiCoreService.appKeyword)
      .set('app-version', this.isophiCoreService.appVersion)
      .set('Accept-Language', this.translocoService.getActiveLang());

    if (this.authService.accessToken) {
      headers = headers.set('Authorization', 'Bearer ' + this.authService.accessToken);
    }

    const currentKindergartenUUID = this.kindergartenService.getCurrentKindergartenUUID();
    if (currentKindergartenUUID) {
      headers = headers.set('X-Current-Kindergarten-UUID', currentKindergartenUUID);
    }

    return next.handle(req.clone({ headers }));
  }
}
